export const translations = {
  en: {
    nav: {
      hero: 'Hero',
      about: 'About',
      music: 'Music',
      seals: 'The Four Seals',
      gallery: 'Gallery',
      roadmap: 'Roadmap',
      contact: 'Contact',
    },
    hero: {
      title1: 'ECLIPSE',
      title2: 'HEAVEN',
      subtitle: 'The Book of the Four Seals',
      tagline: 'Cinematic rock. Sacred resonance.',
      listenSpotify: 'Listen on Spotify',
      youtube: 'YouTube',
      appleMusic: 'Apple Music',
    },
    about: {
      subtitle: 'The Project',
      title: 'About the Project',
      text1: 'Eclipse Heaven is a cinematic rock opus where faith transforms into sound. Each album opens a Seal from the Book: fire, resonance, geometry, and echo.',
      text2: 'Produced by Moonlight Reworks, the project blends human voices, AI choirs, emotional guitars, and sacred sound architecture.',
      text3: "We don't repeat the classics: we bring them back to life.",
      badges: {
        cinematic: 'Cinematic',
        sacred: 'Sacred',
        postHuman: 'Post-Human',
        epic: 'Epic',
        biotech: 'Biotech Aesthetics',
      },
    },
    music: {
      subtitle: 'Divine Fire',
      title: 'Music — Seal I',
      description: 'First seal: purification, fall, and light. A futuristic mass in three acts.',
      listenNow: 'Listen Now',
      tracklist: 'Tracklist',
      tracks: [
        { title: 'Riders', desc: 'prophetic intro' },
        { title: "Heaven's Burn", desc: 'cataclysmic choir & guitars' },
        { title: 'Ashes of Grace', desc: 'prayer among ruins' },
        { title: 'Midnight Memory', desc: 'dual souls' },
        { title: 'Children of the Flame', desc: 'communion in fire' },
        { title: 'Cathedral of Wires', desc: 'the sacred turned electric' },
        { title: 'Faith.exe', desc: 'laser harp + code prayer' },
        { title: 'The Last Prayer', desc: 'intimate plea' },
        { title: 'Angels Made of Smoke', desc: 'memory that glows' },
        { title: 'The Fire Remains', desc: 'rebirth anthem' },
        { title: 'Hollow Kingdom', desc: 'instrumental gaze' },
        { title: 'Rebirth', desc: 'ascension without noise' },
      ],
    },
    seals: {
      subtitle: 'The Saga',
      title: 'The Book of the Four Seals',
      description: 'Four albums. Four gates. A journey from fire to eternal echo.',
      seal1: {
        number: 'I',
        title: 'DIVINE FIRE',
        quote: 'We burned the heavens to find the truth.',
        theme: 'Purification through fire',
        sound: 'EH-V1 (liturgical-cinematic)',
        palette: 'Gold/Crimson',
      },
      seal2: {
        number: 'II',
        title: 'THE RESONANT SOUL',
        quote: 'Even silence remembers the sound of the soul.',
        theme: 'Faith converted into frequency',
        sound: 'EH-V2 (vibrational organic-synthetic)',
        palette: 'Cyan/Liquid Gold',
      },
      seal3: {
        number: 'III',
        title: 'THE FRACTAL KINGDOM',
        quote: 'To build is to remember the ashes.',
        theme: 'Reconstruction/geometric creation',
        sound: 'EH-V3 (hybrid)',
        palette: 'Emerald Green/Pearl Grey',
      },
      seal4: {
        number: 'IV',
        title: 'THE PALE ECHO',
        quote: 'Death is not silence. It is the echo that returns through eternity.',
        theme: 'Eternity and dissolution',
        sound: 'EH-V4 (cosmic minimalism)',
        palette: 'White/Ice Blue',
      },
      labels: {
        theme: 'Theme',
        sound: 'Sound',
        palette: 'Palette',
      },
    },
    gallery: {
      subtitle: 'Visual Universe',
      title: 'Gallery',
      description: 'Explore the visual universe of Eclipse Heaven: crystal altars, divine fire, and sacred geometry.',
    },
    roadmap: {
      subtitle: 'The Journey',
      title: 'Roadmap — From Fire to Resonance',
      milestones: [
        {
          period: 'Q4 2025',
          title: 'Divine Fire (Seal I)',
          description: 'Release + visualizers',
          status: 'In Progress',
        },
        {
          period: 'Q1 2026',
          title: 'The Resonant Soul (Seal II)',
          description: 'Singles release',
          status: 'Coming Soon',
        },
        {
          period: 'Q2 2026',
          title: 'Seal II Full Album',
          description: 'Full album + live session',
          status: 'Coming Soon',
        },
        {
          period: 'Q4 2026',
          title: 'Fractal Kingdom (Seal III)',
          description: 'Concept previews',
          status: 'Coming Soon',
        },
        {
          period: '2027',
          title: 'The Pale Echo (Seal IV)',
          description: 'Immersive show experience',
          status: 'Future',
        },
      ],
      mailingList: {
        title: 'Join the Mailing List',
        description: 'Be the first to know about new releases, exclusive content, and live events.',
        namePlaceholder: 'Your name',
        emailPlaceholder: 'Your email',
        subscribe: 'Subscribe',
      },
    },
    contact: {
      subtitle: 'Get In Touch',
      title: 'Press & Contact',
      pressInfo: {
        title: 'Press Information',
        quote: 'Eclipse Heaven is a cinematic rock opera where faith burns, resonates, rebuilds, and returns as echo. A sacred-futurist sound that merges human voices, AI choirs, emotional guitars and laser-harp in F.',
        downloadKit: 'Download Press Kit',
        booking: 'Booking',
        label: 'Label',
      },
      followUs: 'Follow Us',
      contactForm: {
        title: 'Send a Message',
        nameLabel: 'Name',
        emailLabel: 'Email',
        messageLabel: 'Message',
        send: 'Send Message',
      },
    },
    footer: {
      tagline: 'Cinematic rock opera where faith burns, resonates, rebuilds, and returns as echo.',
      music: 'Music',
      social: 'Social',
      contact: 'Contact',
      legal: 'Legal',
      copyright: '© 2025 Moonlight Reworks. Eclipse Heaven — All Rights Reserved.',
      aiDisclaimer: 'AI-assisted composition with human direction. All compositions © Rubén Izquierdo.',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
    toasts: {
      nameRequired: 'Please enter your name',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Please enter a valid email address',
      messageRequired: 'Please enter a message',
      subscribeSuccess: 'Successfully joined the mailing list! 🎉',
      messageSuccess: 'Message sent successfully! We will get back to you soon. 🎉',
    },
  },
  es: {
    nav: {
      hero: 'Inicio',
      about: 'Acerca',
      music: 'Música',
      seals: 'Los Cuatro Sellos',
      gallery: 'Galería',
      roadmap: 'Hoja de Ruta',
      contact: 'Contacto',
    },
    hero: {
      title1: 'ECLIPSE',
      title2: 'HEAVEN',
      subtitle: 'El Libro de los Cuatro Sellos',
      tagline: 'Rock cinematográfico. Resonancia sagrada.',
      listenSpotify: 'Escuchar en Spotify',
      youtube: 'YouTube',
      appleMusic: 'Apple Music',
    },
    about: {
      subtitle: 'El Proyecto',
      title: 'Acerca del Proyecto',
      text1: 'Eclipse Heaven es una obra de rock cinematográfico donde la fe se convierte en sonido. Cada álbum abre un Sello del Libro: fuego, resonancia, geometría y eco.',
      text2: 'Producido por Moonlight Reworks, el proyecto mezcla voces humanas, coros IA, guitarras emotivas y arquitectura sonora sacra.',
      text3: 'No repetimos los clásicos: los devolvemos a la vida.',
      badges: {
        cinematic: 'Cinematográfico',
        sacred: 'Sagrado',
        postHuman: 'Post-Humano',
        epic: 'Épico',
        biotech: 'Estética Biotech',
      },
    },
    music: {
      subtitle: 'Fuego Divino',
      title: 'Música — Sello I',
      description: 'Primer sello: purificación, caída y luz. Una misa futurista en tres actos.',
      listenNow: 'Escuchar Ahora',
      tracklist: 'Lista de Canciones',
      tracks: [
        { title: 'Riders', desc: 'intro profético' },
        { title: "Heaven's Burn", desc: 'coro cataclísmico y guitarras' },
        { title: 'Ashes of Grace', desc: 'oración entre ruinas' },
        { title: 'Midnight Memory', desc: 'almas duales' },
        { title: 'Children of the Flame', desc: 'comunión en fuego' },
        { title: 'Cathedral of Wires', desc: 'lo sagrado vuelto eléctrico' },
        { title: 'Faith.exe', desc: 'arpa láser + oración código' },
        { title: 'The Last Prayer', desc: 'súplica íntima' },
        { title: 'Angels Made of Smoke', desc: 'memoria que brilla' },
        { title: 'The Fire Remains', desc: 'himno del renacer' },
        { title: 'Hollow Kingdom', desc: 'mirada instrumental' },
        { title: 'Rebirth', desc: 'ascensión sin ruido' },
      ],
    },
    seals: {
      subtitle: 'La Saga',
      title: 'El Libro de los Cuatro Sellos',
      description: 'Cuatro álbumes. Cuatro puertas. Un viaje desde el fuego hasta el eco eterno.',
      seal1: {
        number: 'I',
        title: 'FUEGO DIVINO',
        quote: 'Quemamos los cielos para encontrar la verdad.',
        theme: 'Purificación a través del fuego',
        sound: 'EH-V1 (litúrgico-cinemático)',
        palette: 'Dorado/Carmesí',
      },
      seal2: {
        number: 'II',
        title: 'EL ALMA RESONANTE',
        quote: 'Incluso el silencio recuerda el sonido del alma.',
        theme: 'Fe convertida en frecuencia',
        sound: 'EH-V2 (vibracional orgánico-sintético)',
        palette: 'Cian/Oro líquido',
      },
      seal3: {
        number: 'III',
        title: 'EL REINO FRACTAL',
        quote: 'Construir es recordar las cenizas.',
        theme: 'Reconstrucción/creación geométrica',
        sound: 'EH-V3 (híbrido)',
        palette: 'Verde esmeralda/Gris perla',
      },
      seal4: {
        number: 'IV',
        title: 'EL ECO PÁLIDO',
        quote: 'La muerte no es silencio. Es el eco que regresa por la eternidad.',
        theme: 'Eternidad y disolución',
        sound: 'EH-V4 (minimalismo cósmico)',
        palette: 'Blanco/Azul hielo',
      },
      labels: {
        theme: 'Tema',
        sound: 'Sonido',
        palette: 'Paleta',
      },
    },
    gallery: {
      subtitle: 'Universo Visual',
      title: 'Galería',
      description: 'Explora el universo visual de Eclipse Heaven: altares de cristal, fuego divino y geometría sagrada.',
    },
    roadmap: {
      subtitle: 'El Viaje',
      title: 'Hoja de Ruta — Del Fuego a la Resonancia',
      milestones: [
        {
          period: 'Q4 2025',
          title: 'Fuego Divino (Sello I)',
          description: 'Lanzamiento + visualizadores',
          status: 'En Progreso',
        },
        {
          period: 'Q1 2026',
          title: 'El Alma Resonante (Sello II)',
          description: 'Lanzamiento de singles',
          status: 'Próximamente',
        },
        {
          period: 'Q2 2026',
          title: 'Álbum Completo Sello II',
          description: 'Álbum completo + sesión en vivo',
          status: 'Próximamente',
        },
        {
          period: 'Q4 2026',
          title: 'Reino Fractal (Sello III)',
          description: 'Avances del concepto',
          status: 'Próximamente',
        },
        {
          period: '2027',
          title: 'El Eco Pálido (Sello IV)',
          description: 'Experiencia de show inmersivo',
          status: 'Futuro',
        },
      ],
      mailingList: {
        title: 'Únete a la Lista de Correo',
        description: 'Sé el primero en saber sobre nuevos lanzamientos, contenido exclusivo y eventos en vivo.',
        namePlaceholder: 'Tu nombre',
        emailPlaceholder: 'Tu email',
        subscribe: 'Suscribirse',
      },
    },
    contact: {
      subtitle: 'Ponte en Contacto',
      title: 'Prensa y Contacto',
      pressInfo: {
        title: 'Información de Prensa',
        quote: 'Eclipse Heaven es una ópera de rock cinematográfico donde la fe arde, resuena, reconstruye y regresa como eco. Un sonido sagrado-futurista que fusiona voces humanas, coros IA, guitarras emotivas y arpa láser en Fa.',
        downloadKit: 'Descargar Kit de Prensa',
        booking: 'Contratación',
        label: 'Sello',
      },
      followUs: 'Síguenos',
      contactForm: {
        title: 'Enviar Mensaje',
        nameLabel: 'Nombre',
        emailLabel: 'Correo',
        messageLabel: 'Mensaje',
        send: 'Enviar Mensaje',
      },
    },
    footer: {
      tagline: 'Ópera de rock cinematográfico donde la fe arde, resuena, reconstruye y regresa como eco.',
      music: 'Música',
      social: 'Social',
      contact: 'Contacto',
      legal: 'Legal',
      copyright: '© 2025 Moonlight Reworks. Eclipse Heaven — Todos los Derechos Reservados.',
      aiDisclaimer: 'Composición asistida por IA con dirección humana. Todas las composiciones © Rubén Izquierdo.',
      terms: 'Términos de Servicio',
      privacy: 'Política de Privacidad',
    },
    toasts: {
      nameRequired: 'Por favor ingresa tu nombre',
      emailRequired: 'Por favor ingresa tu email',
      emailInvalid: 'Por favor ingresa un email válido',
      messageRequired: 'Por favor ingresa un mensaje',
      subscribeSuccess: '¡Te has unido a la lista de correo exitosamente! 🎉',
      messageSuccess: '¡Mensaje enviado exitosamente! Te responderemos pronto. 🎉',
    },
  },
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};